export default __webpack_public_path__ + "static/media/holidaytxt.8ac43f39.png";